<script setup>
import { defineProps, defineEmits, toRef, watch, computed } from 'vue';
import MultiSelect from 'vue-multiselect';

const props = defineProps(['modelValue', 'types', 'openFilters', 'toggleFilters'])
const emit = defineEmits(['update:modelValue', 'update:openFilters'])

const model = computed(() => {
  return new Proxy(props.modelValue, {
    set(obj, key, value) {
      emit('update:modelValue', { ...obj, [key]: value })
      return true
    }
  })
})

const options = computed(() => {
  return Object.keys(props.types);
})

</script>

<template>
  <div class="stadsnatuur-map-filters" :class="{ 'is-open': openFilters }">
    <div class="stadsnatuur-map-filters-heading">
      <h2>Filteren</h2>
      <button class="stadsnatuur-map-filters-close" @click="toggleFilters(false)">
        <span class="screen-reader-text">
          Sluiten
        </span>
        <svg class="icon icon-icon-close">
          <use xlink:href="#icon-close"></use>
        </svg>
      </button>
    </div>

    <multi-select
      id="multiselect"
      v-model="model.types"
      :options="options"
      :multiple="true"
      :searchable="false"
      :close-on-select="false"
      :clear-on-select="false"
      class="stadsnatuur-map-filter"
      placeholder="Type activiteit"
      :custom-label="(option) => props.types[option]"
    >
      <template #selection="{ values, isOpen }">
        <span class="multiselect__single" v-if="values.length">
          Type activiteit
          ({{ values.length }})
        </span>
      </template>
    </multi-select>

    <label class="stadsnatuur-map-filter">
      <input type="checkbox" v-model="model.gratis" />
      <span class="stadsnatuur-map-filter__text">
        Gratis activiteiten
      </span>
    </label>

    <label class="stadsnatuur-map-filter">
      <input type="checkbox" v-model="model.kinderen" />
      <span class="stadsnatuur-map-filter__text">
        Kindvriendelijk
      </span>
    </label>

    <label class="stadsnatuur-map-filter">
      <input type="checkbox" v-model="model.rolstoel" />
      <span class="stadsnatuur-map-filter__text">
        Rolstoelvriendelijk
      </span>
    </label>

    <button class="stadsnatuur-map-filters-apply" @click="toggleFilters(false)">
      Toon resultaten
    </button>
  </div>
</template>

<style scoped></style>